import React from 'react';
import './Benifits.css';

const Benifits = () => {
    return (
        <div className='Benifits'>
            <h1>Our Benifits__</h1>
            <h3>*There will be a friendly environment</h3>
            <h3>*Learn statistics form basic</h3>
            <h3>*Qualifications like getting first class are developed</h3>
            <h3>*As well as non-major will be shown</h3>
            <h3>*There will be extra care for the weak</h3>
            <h3>*There will be many testing arrangements</h3>
            <h3>*There will be extra classes for those who will do well in the exam</h3>


        </div>
    );
};

export default Benifits;